import type { AxiosError } from 'axios';

export const isPermissionDeniedError = (error: AxiosError<{ message?: { permission_id?: string } }>): boolean =>
  error?.response?.status === 403 && Boolean(error?.response?.data?.message?.permission_id);
